import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { PAYMENT_LINK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { PAYMENT_LINK_NEW_BADGE_PHASE_2 } from '../../constants/GateConstants';
import { useAssociatedObjectsCardContext } from '../../context/AssociatedObjectsCardContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AssociatedObjectsCardTitle() {
  var _associationTypes$, _associationsData$imp, _associationsData$imp2;
  const {
    associationTypesData: {
      associationTypes
    },
    associationsData,
    isUngated,
    title,
    toObjectTypeId
  } = useAssociatedObjectsCardContext();
  const objectPluralForm = associationTypes === null || associationTypes === void 0 || (_associationTypes$ = associationTypes[0]) === null || _associationTypes$ === void 0 || (_associationTypes$ = _associationTypes$.toObjectTypeDefinition) === null || _associationTypes$ === void 0 ? void 0 : _associationTypes$.pluralForm;
  const isNew = toObjectTypeId === PAYMENT_LINK_TYPE_ID;
  const isUngatedForPhase2 = isUngated(PAYMENT_LINK_NEW_BADGE_PHASE_2);
  const displayNewBadge = isNew && isUngatedForPhase2;
  const total = (_associationsData$imp = associationsData === null || associationsData === void 0 || (_associationsData$imp2 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp2 === void 0 ? void 0 : _associationsData$imp2.total) !== null && _associationsData$imp !== void 0 ? _associationsData$imp : 0;
  return /*#__PURE__*/_jsxs("span", {
    children: [associationTypes.length && associationsData !== null && associationsData !== void 0 && associationsData.impliedUnlabeledAssociationObjects ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.title.GENERIC.exact",
      options: {
        count: total,
        label: title || objectPluralForm
      }
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: title !== null && title !== void 0 ? title : ''
    }), displayNewBadge && /*#__PURE__*/_jsx(Badge, {
      use: "new",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.title.GENERIC.new"
      })
    })]
  });
}
export default AssociatedObjectsCardTitle;